import React, { useState, useEffect } from "react";
import "./Timeline.css";
import { timeline } from "./jobList";

function Timeline() {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const timelineSection = document.querySelector("#timeline");
    
    if (!timelineSection) return;

    const observerOptions = {
      root: null,
      rootMargin: "-100px 0px",
      threshold: 0.1,
    };

    const intersectionCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isActive) {
          setIsActive(true);
        }
      });
    };

    const observer = new IntersectionObserver(
      intersectionCallback,
      observerOptions
    );

    observer.observe(timelineSection);

    return () => {
      observer.disconnect();
    };
  }, [isActive]);

  const filteredTimeline = timeline.filter(item => 
    item.company && item.title && (item.date || item.description)
  );

  const timelineList = filteredTimeline.map((item, index) => {
    return (
      <div
        key={`timeline-${index}`}
        className={`timeline_container ${isActive ? "active" : ""} ${item.className}`}
      >
        <div className="timeline_text">
          <h2>{item.company}</h2>
          <h3>{item.title}</h3>
          {item.date && (
            <div className="date">{item.date}</div>
          )}
          {item.description && (
            <p>{item.description}</p>
          )}
          {item.skills && (
            <div className="skills">
              <strong>Skills:</strong> {item.skills}
            </div>
          )}
          {/* <span className={`timeline_arrow ${item.className}`}></span> */}
        </div>
      </div>
    );
  });

  return (
    <div className="timeline_section">
      <h2 className="section-title">My Journey</h2>
      <div id="timeline" className={`timeline ${isActive ? "active" : ""}`}>
        {timelineList.length > 0 ? timelineList : (
          <div className="timeline_container active left-container">
            <div className="timeline_text">
              <h2>No Experience Yet</h2>
              <h3>Building My Skills</h3>
              <div className="date">Present</div>
              <p>Currently developing my skills and working on exciting projects.</p>
              {/* <span className="timeline_arrow left-container"></span> */}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Timeline;
